export function trapFocus(container: HTMLElement) {
    if (!container) return;

    const focusableSelectors =
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

    const focusable = Array.from(
        container.querySelectorAll<HTMLElement>(focusableSelectors)
    ).filter(el => el.offsetParent !== null); // ta bort osynliga element

    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    function handleKeyDown(e: KeyboardEvent) {
        if (e.key !== "Tab") return;

        if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();
        }

        if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            last.focus();
        }
    }

    container.addEventListener("keydown", handleKeyDown);

    // Returnera cleanup-funktion
    return () => {
        container.removeEventListener("keydown", handleKeyDown);
    };
}